import task from './task';
import aufgaben from './aufgaben';
import freigabe from './freigabe';

export default {
  task,
  aufgaben,
  freigabe,
};
